import { render, staticRenderFns } from "./DeleteCategory.vue?vue&type=template&id=6cd3ed2a&scoped=true&"
import script from "./DeleteCategory.vue?vue&type=script&lang=js&"
export * from "./DeleteCategory.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCategory.vue?vue&type=style&index=0&id=6cd3ed2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3ed2a",
  null
  
)

component.options.__file = "DeleteCategory.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
